import { fetchAirlines } from "./airFetcher"

export const universalFetch = (url, method = "POST", data = {}) => {
  let body
  const headers = {
    Accept: "application/json",
    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
  }

  if (data instanceof FormData) {
    body = data
  } else {
    body = JSON.stringify(data)
    headers["Content-Type"] = "application/json"
  }

  return fetch(url, {
    method: method.toUpperCase(),
    headers,
    body: method.toUpperCase() === "GET" ? undefined : body,
  }).then((response) => {
    if (!response.ok) throw new Error("fetch error")
    return response.json()
  })
}

export const Api = {
  fetch: universalFetch,
  fetchAirlines: fetchAirlines,
}
